/**
 * @desc 前往出价时的身份验证
 */
import { AuthenticateIdentityForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuthenticateIdentityParameter = AuthenticateIdentityForm

const method = 'POST'
const url = '/trade/mall/auction/identityAuthentication'

export const authenticateIdentityApi = (
  data?: AuthenticateIdentityParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

authenticateIdentityApi.method = method
authenticateIdentityApi.url = url
